/* Exact product-page handoff and public catalog GETs. No private APIs or customer uploads. */
(function (root, factory) {
  'use strict';
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.SeeGartProductContext = api;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  const list = value => Array.isArray(value) ? value : [];
  function key(value, type) {
    if (typeof value === 'number' && !Number.isSafeInteger(value)) return '';
    const text = String(value == null ? '' : value);
    const match = new RegExp('^(?:gid://shopify/' + type + '/)?([0-9]+)$').exec(text);
    return match ? match[1] : '';
  }
  function result(status, error) {
    return { status, hasRequest: status !== 'none', valid: status === 'valid', productIndex: null, sizeIndex: null,
      finish: null, productId: null, variantId: null, variantProvided: false, error: error || null };
  }
  function parse(products, search) {
    let params;
    try {
      // This accepts location.search or URLSearchParams, not an arbitrary URL.
      const input = String(search == null ? '' : search);
      if (/^[a-z][a-z0-9+.-]*:/i.test(input) || input.startsWith('//')) return result('invalid', 'invalid_query');
      params = new URLSearchParams(input);
    } catch (error) { return result('invalid', 'invalid_query'); }
    if (!params.has('product') && !params.has('variant')) return result('none');
    if (params.getAll('product').length > 1 || params.getAll('variant').length > 1) return result('invalid', 'duplicate_parameter');
    if (!params.has('product')) return result('invalid', 'missing_product');
    const requested = params.get('product');
    if (!requested) return result('invalid', 'missing_product_value');
    const productKey = key(requested, 'Product');
    const matches = list(products).map((product, index) => ({ product, index })).filter(({ product }) => product && (
      String(product.handle || '') === requested || String(product.id || '') === requested ||
      (productKey && (key(product.id, 'Product') === productKey || key(product.numericId, 'Product') === productKey))
    ));
    if (!matches.length) return result('invalid', 'unknown_product');
    if (matches.length !== 1) return result('invalid', 'ambiguous_product');
    const { product, index } = matches[0], variants = list(product.variants);
    const explicit = params.has('variant');
    let variant;
    if (explicit) {
      const variantKey = key(params.get('variant'), 'ProductVariant');
      if (!params.get('variant')) return result('invalid', 'missing_variant_value');
      if (!variantKey) return result('invalid', 'unknown_variant');
      const found = variants.filter(v => v && key(v.id, 'ProductVariant') === variantKey);
      if (!found.length) {
        const elsewhere = list(products).some(p => p && p !== product && list(p.variants).some(v => v && key(v.id, 'ProductVariant') === variantKey));
        return result('invalid', elsewhere ? 'variant_product_mismatch' : 'unknown_variant');
      }
      if (found.length !== 1) return result('invalid', 'ambiguous_variant');
      variant = found[0];
    } else variant = variants[0];
    if (!variant || !key(variant.id, 'ProductVariant')) return result('invalid', 'product_has_no_variants');
    const sizeIndex = list(product.sizes).indexOf(list(variant.options)[0]);
    const finish = list(variant.options)[1];
    if (sizeIndex < 0 || typeof finish !== 'string' || !list(product.finishes).includes(finish)) return result('invalid', 'variant_options_unmapped');
    return { ...result('valid'), productIndex: index, sizeIndex, finish,
      productId: String(product.id == null ? product.numericId : product.id),
      variantId: String(variant.id), variantProvided: explicit };
  }
  function buildUrl(base, product, variant) {
    const fail = error => ({ valid: false, url: null, error });
    if (typeof base !== 'string' || !base || /[\\\u0000-\u0020\u007f]/.test(base) || /^[a-z][a-z0-9+.-]*:/i.test(base) || base.startsWith('//')) return fail('unsafe_base');
    const parts = /^([^?#]+)(?:\?([^#]*))?(#.*)?$/.exec(base);
    if (!parts) return fail('unsafe_base');
    try {
      const decodedPath = decodeURIComponent(parts[1]);
      if (decodedPath.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(decodedPath) || /^[a-z][a-z0-9+.-]*:/i.test(decodedPath)) return fail('unsafe_base');
    } catch (error) { return fail('unsafe_base'); }
    if (!product || typeof product !== 'object') return fail('unknown_product');
    const variantId = variant && typeof variant === 'object' ? variant.id : variant;
    if (variantId == null || variantId === '') return fail('missing_variant');
    const productId = key(product.numericId, 'Product') || key(product.id, 'Product') || product.handle;
    if (!productId) return fail('unknown_product');
    const selection = new URLSearchParams(); selection.set('product', String(productId)); selection.set('variant', String(variantId));
    const checked = parse([product], selection);
    if (!checked.valid) return fail(checked.error);
    const query = new URLSearchParams(parts[2] || '');
    query.set('product', String(productId)); query.set('variant', key(checked.variantId, 'ProductVariant'));
    return { valid: true, url: parts[1] + '?' + query.toString() + (parts[3] || ''), error: null };
  }
  function safeHandle(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 255 && /^[\p{L}\p{N}_-]+$/u.test(value) ? value : null;
  }
  function imageUrl(value) {
    const source = typeof value === 'string' ? value : value && (value.src || value.url);
    if (typeof source !== 'string') return null;
    const url = source.startsWith('//') ? 'https:' + source : source;
    return /^https:\/\/(?:cdn\.shopify\.com|seegart\.com)\//i.test(url) ? url : null;
  }
  function sameImageSource(first,second) {
    if(typeof first!=='string'||typeof second!=='string')return false;
    const parts=value=>{const [path,query]=value.split('?');return {file:path.split('/').pop(),version:new URLSearchParams(query||'').get('v')};};
    const a=parts(first),b=parts(second);
    return Boolean(a.file&&a.file===b.file&&(!a.version||!b.version||a.version===b.version));
  }
  function previewImageIdentity(value) {
    if(typeof value!=='string')return null;
    // The same shop image is exposed through both storefront and CDN hosts.
    // Width transforms do not change source identity; a new v always does.
    const match=/^https:\/\/(?:cdn\.shopify\.com\/s\/files\/1\/0784\/1205\/4665\/files\/|seegart\.com\/cdn\/shop\/files\/)([^/?#]+)(?:\?([^#]*))?(?:#.*)?$/.exec(value);
    if(!match)return null;
    return match[1]+'?v='+(new URLSearchParams(match[2]||'').get('v')||'');
  }
  function samePreviewImage(first,second) {
    if(typeof first!=='string'||typeof second!=='string')return false;
    if(first===second)return true;
    const a=previewImageIdentity(first),b=previewImageIdentity(second);
    return Boolean(a&&a===b);
  }
  function previewPhotos(product) {
    if(!product)return [];
    const scoped=list(root?.SEEGART_ARTWORK_CALIBRATIONS?.products).some(prepared=>
      prepared.sourceBinding&&key(prepared.productId,'Product')===key(product.id,'Product'));
    const seen=new Set();
    return [product.image,...list(product.images)].filter(source=>{
      if(typeof source!=='string'||!source)return false;
      const identity=previewImageIdentity(source)||source;
      if(scoped&&/^seegart-3dp-guide-\d+-(?:frame-guide|packaging-guide)-[a-f0-9]{16}\.(?:png|jpe?g|webp)\?v=/.test(identity))return false;
      if(seen.has(identity))return false;
      seen.add(identity);return true;
    });
  }
  function boundImageSource(binding, current) {
    if (!binding || !sameImageSource(binding.url,current)) return false;
    if (!binding.requireVersion) return true;
    const version=value=>new URLSearchParams(String(value).split('?')[1]||'').get('v');
    return Boolean(version(binding.url) && version(binding.url)===version(current));
  }
  function validSourceRegion(prepared) {
    const c=prepared?.sourceRect,d=prepared?.sourceSize;
    return Boolean(prepared?.visuallyChecked&&prepared?.previewSupported&&c&&d&&
      [c.x,c.y,c.width,c.height,d.width,d.height].every(Number.isFinite)&&
      c.x>=0&&c.y>=0&&c.width>0&&c.height>0&&d.width>0&&d.height>0&&
      c.x+c.width<=d.width&&c.y+c.height<=d.height);
  }
  function currentCalibration(productId,primaryImage) {
    // Explicit product/source pairs also cover products discovered after the
    // static catalog snapshot. Never reuse a crop for a replaced photograph.
    return list(root?.SEEGART_ARTWORK_CALIBRATIONS?.products).find(prepared=>
      key(prepared.productId,'Product')===productId&&prepared.sourceBinding&&
      validSourceRegion(prepared)&&boundImageSource(prepared.sourceBinding,primaryImage));
  }
  function normalizeProduct(raw, previous) {
    if (!raw || !key(raw.id, 'Product') || !safeHandle(raw.handle)) throw new Error('Invalid public product data');
    const optionNames = list(raw.options).map(option => typeof option === 'string' ? option : String(option && option.name || ''));
    const clean = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    const sizeIndex = optionNames.findIndex(name => ['size', 'canvassize'].includes(clean(name)));
    const finishIndex = optionNames.findIndex(name => ['canvasorframeoption', 'frame', 'finish', 'frameoption', 'framing'].includes(clean(name)));
    const variants = list(raw.variants).filter(v => v && key(v.id, 'ProductVariant')).map(v => {
      const original = Array.isArray(v.options) ? v.options : [v.option1, v.option2, v.option3].slice(0, optionNames.length);
      return {id:key(v.id, 'ProductVariant'), options:[sizeIndex >= 0 ? original[sizeIndex] : '', finishIndex >= 0 ? original[finishIndex] : ''], originalOptions:original, available:v.available, price:v.price, sku:v.sku || ''};
    });
    const sizes = [...new Set((variants.length ? variants.map(v => v.options[0]) : list(list(raw.options)[sizeIndex]?.values)).filter(value => typeof value === 'string'))];
    const finishes = [...new Set((variants.length ? variants.map(v => v.options[1]) : list(list(raw.options)[finishIndex]?.values)).filter(value => typeof value === 'string'))];
    const images = [...new Set([imageUrl(raw.featured_image), ...list(raw.images).map(imageUrl), imageUrl(raw.image)].filter(Boolean))];
    const id = key(raw.id, 'Product'), old = previous && key(previous.id, 'Product') === id ? previous : {};
    // The snapshot's crop remains an optional visual enhancement. Live catalog
    // identity, option strings and variant IDs always replace the snapshot.
    const reviewed = old.projectionProvenance === 'visually-reviewed-source-region' || (old.imageMode==='artwork'&&/^Visually checked inner-artwork region/.test(old.sourceRectNote||'')&&/^[a-f0-9]{64}$/.test(old.sourceSha256||''));
    const matched=currentCalibration(id,images[0]);
    const retained=reviewed && old.sourceRect && (old.sourceBinding ? boundImageSource(old.sourceBinding,images[0]) : sameImageSource(old.thumbnail,images[0]));
    const prepared=matched||old,calibrated=Boolean(matched||retained);
    const metricPairs=sizes.map(value=>/\/\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm\s*$/i.exec(value));
    // SeeGart's established unlabeled landscape SIZE convention is H × W.
    // Require every size to follow it; never infer dimensions from a photo.
    const landscape=sizes.length>0&&sizes.every((value,index)=>!/[hw]/i.test(value.split('/')[0])&&metricPairs[index]&&Number(metricPairs[index][1])<Number(metricPairs[index][2]));
    const square=sizes.length>0&&metricPairs.every(pair=>pair&&Number(pair[1])===Number(pair[2]));
    const family = sizes.some(value => /2\s*p\b/i.test(value)) ? 'diptych' : matched?.family || old.family || (square?'square':landscape?'landscape':'unknown');
    return {...old, id:'gid://shopify/Product/' + id, numericId:id, handle:raw.handle, title:String(raw.title || raw.handle),
      url:'/products/' + encodeURIComponent(raw.handle), images, thumbnail:images[0] || old.thumbnail || '',
      image:calibrated ? (matched ? images[0] : old.image) : images[0] || '', sourceRect:calibrated ? prepared.sourceRect : undefined,
      sourceSize:calibrated ? prepared.sourceSize : undefined, sourceBinding:calibrated ? prepared.sourceBinding : undefined,
      imageMode:calibrated ? 'artwork' : 'product-photo',
      previewSupported:Boolean(images.length || calibrated), family, sizes:sizes.length ? sizes : [''], finishes:finishes.length ? finishes : [''],
      options:[{name:sizeIndex >= 0 ? optionNames[sizeIndex] : '', values:sizes}, {name:finishIndex >= 0 ? optionNames[finishIndex] : '', values:finishes}],
      variants, variantCount:variants.length, live:variants.length>0, liveVerifiedAt:variants.length?Date.now():null, optionMappingKnown:sizeIndex >= 0,
      projectionProvenance:calibrated ? 'visually-reviewed-source-region' : 'live-product-photograph'};
  }
  function mergeListing(raw,previous) {
    const fresh=normalizeProduct(raw,previous);
    if(!previous)return fresh;
    const samePrimary=sameImageSource(previous.thumbnail,fresh.thumbnail);
    return {...previous,handle:fresh.handle,title:fresh.title,url:fresh.url,thumbnail:fresh.thumbnail,image:fresh.image,
      sourceRect:fresh.sourceRect,sourceSize:fresh.sourceSize,sourceBinding:fresh.sourceBinding,imageMode:fresh.imageMode,projectionProvenance:fresh.projectionProvenance,
      images:samePrimary&&previous.images?.length?previous.images:fresh.images,catalogVisible:true};
  }
  function createPublicLoader(fetcher, rootPath) {
    if (typeof fetcher !== 'function') throw new Error('A public fetch function is required');
    const prefix = typeof rootPath === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(rootPath) ? rootPath : '/';
    const pending = new Map();
    async function get(path) {
      if (pending.has(path)) return pending.get(path);
      const promise = (async () => {
        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = controller ? setTimeout(() => controller.abort(), 12000) : null;
        try {
          const response = await fetcher(prefix + path, {method:'GET', credentials:'same-origin', cache:'no-store', ...(controller ? {signal:controller.signal} : {})});
          if (!response.ok) {const error = new Error('Public catalog request failed'); error.status = response.status; throw error;}
          return await response.json();
        } finally {if (timer) clearTimeout(timer);}
      })();
      pending.set(path, promise);
      try {return await promise;} finally {pending.delete(path);}
    }
    async function product(handle, previous) {
      if (!safeHandle(handle)) throw new Error('Invalid product handle');
      return normalizeProduct(await get('products/' + encodeURIComponent(handle) + '.js'), previous);
    }
    async function products(collection, onPage) {
      if (collection !== 'all' && !safeHandle(collection)) throw new Error('Invalid collection handle');
      const prefixPath = 'collections/' + encodeURIComponent(collection);
      const seen = new Set(), all = [];
      for (let page = 1; page <= 100; page++) {
        const payload = await get(prefixPath + '?view=room-catalog&page=' + page), batch = list(payload.products);
        if (!Array.isArray(payload.products)) throw new Error('Invalid public product list');
        let added = 0;
        for (const raw of batch) if (key(raw.id, 'Product') && !seen.has(key(raw.id, 'Product'))) {seen.add(key(raw.id, 'Product')); all.push(raw); added++;}
        if (onPage) onPage(batch);
        if (payload.has_more === false || (payload.has_more !== true && batch.length < 250)) return all;
        if (!added) throw new Error('Repeated catalog page');
      }
      throw new Error('Public catalog page limit reached');
    }
    async function collections() {
      const found = [], seen = new Set();
      for (let page = 1; page <= 100; page++) {
        const payload = await get('collections.json?limit=250&page=' + page);
        if (!Array.isArray(payload.collections)) throw new Error('Invalid public collection list');
        let added = 0;
        for (const c of payload.collections) if (safeHandle(c.handle) && !seen.has(c.handle)) {seen.add(c.handle);found.push({id:String(c.id),handle:c.handle,title:String(c.title),productIds:[],live:true});added++;}
        if (payload.collections.length < 250) return found;
        if (!added) throw new Error('Repeated collection page');
      }
      throw new Error('Public collection page limit reached');
    }
    return Object.freeze({product, products, collections});
  }
  return Object.freeze({ parse, buildUrl, safeHandle, normalizeProduct, mergeListing, createPublicLoader, previewPhotos, samePreviewImage });
});
